import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapHoriz = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.66634 13.3337L1.33301 10.0003L4.66634 6.66699L5.59967 7.61699L3.88301 9.33366H8.66634V10.667H3.88301L5.59967 12.3837L4.66634 13.3337ZM11.333 9.33366L10.3997 8.38366L12.1163 6.66699H7.33301V5.33366H12.1163L10.3997 3.61699L11.333 2.66699L14.6663 6.00033L11.333 9.33366Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgSwapHoriz);
export default ForwardRef;
